module.exports = __webpack_public_path__ + "static/media/home_thought_512.1df67f5b.png";